<div class="modal-header px-3 py-2 border-light-subtle">
    <h5 class="modal-title fw-semibold">Enter Your Name</h5>
    <button type="button" class="btn-close" (click)="dismiss()"></button>
</div>
<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body">
        <div class="mb-3">
            <label class="form-label fw-semibold" for="personName">
                What's your name?
            </label>
            <input
                id="personName"
                class="form-control"
                formControlName="name"
                placeholder="Enter your name"
                [class.is-invalid]="nameControl.touched && nameControl.invalid"
                autofocus
            />
            @if (nameControl.touched && nameControl.hasError('required')) {
                <div class="invalid-feedback d-block">
                    Please enter your name
                </div>
            }
            @if (showDuplicateError) {
                <div class="invalid-feedback d-block">
                    {{ duplicateErrorMessage }}
                </div>
            }
        </div>
        <p class="text-muted small mb-0">
            This helps us identify your choices for the booking.
        </p>
    </div>
    <div
        class="modal-footer"
        appVenueColour
        [primaryColour]="venue?.primaryColour"
    >
        <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">
            Cancel
        </button>
        <button
            type="submit"
            class="btn btn-primary"
            [disabled]="form.invalid"
        >
            Continue
        </button>
    </div>
</form>
